import React, { useContext, useEffect, useState } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import { useTheme } from '../../../contexts/ThemeContext';
import TechLoader from '../../common/TechLoader';
import publicData from '../../../data/publicData.json';

const Layout = ({ children }) => {
  const { theme, toggleTheme } = useTheme();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate initial loading
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    // Update body class for consistent theming
    document.body.className = theme === 'dark' ? 'bg-gray-900' : 'bg-gray-50';
  }, [theme]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <TechLoader size="large" text="Loading..." />
      </div>
    );
  }

  return (
    <div className={`min-h-screen flex flex-col transition-colors duration-200 ${
      theme === 'dark' 
        ? 'bg-gray-900 text-white' 
        : 'bg-gray-50 text-gray-900'
    }`}>
      <Navbar theme={theme} companyInfo={publicData.company} />
      <main className="flex-grow">{children}</main>
      <Footer theme={theme} companyInfo={publicData.company} />
    </div>
  );
};

export default Layout;
